import script from "./ModalContact.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalContact.vue?vue&type=script&setup=true&lang=js"

import "./ModalContact.vue?vue&type=style&index=0&id=eaf652de&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eaf652de"]])

export default __exports__